<div class="chat-area col">
    <div class="chat-content {[ if (o.show_send_button) { ]}chat-content-sendbutton{[ } ]}"></div>
    <div class="message-form-container"/>
</div>
